import { render } from "./CustomerInquery.vue?vue&type=template&id=3d4ed7f3"
import script from "./CustomerInquery.vue?vue&type=script&lang=js"
export * from "./CustomerInquery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__